import { lazy } from 'react';

const SendTransferConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/manager/consults/send/transfer-info',
			component: lazy(() => import('./SendTransferContainer'))
		}
	]
};

export default SendTransferConfig;

